module.exports = __webpack_public_path__ + "static/media/trace-light.5e0f4c9b.png";